import { SVGAttributes } from 'react'

export default function BrandsOval(attributes: SVGAttributes<SVGSVGElement>): JSX.Element {
	return (
		<svg {...attributes} viewBox="0 0 2369 508" fill="none" xmlns="http://www.w3.org/2000/svg">
			<ellipse cx="1184.5" cy="256" rx="1184.5" ry="254" fill="#F8F9FA" />
			<path d="M483.664 89.48c36.19-5.513 73.087-10.583 110.236-14.965" stroke="#79C2BE" strokeWidth="12" strokeMiterlimit="10" strokeLinecap="round" />
			<path d="M537.279 38.483c68.031-9.28 137.814-16.68 206.839-20.896" stroke="#8DC63F" strokeWidth="16" strokeMiterlimit="10" strokeLinecap="round" />
			<path d="M423.421 66.202c80.432-12.8 163.609-24.057 247.399-32.785" stroke="#6BAF45" strokeWidth="16" strokeMiterlimit="10" strokeLinecap="round" style={{ mixBlendMode: 'multiply' }} />
			<path d="M1873.54 423.705c-36.19 5.513-73.08 10.583-110.23 14.965" stroke="#79C2BE" strokeWidth="12" strokeMiterlimit="10" strokeLinecap="round" />
			<path d="M1819.93 474.701c-68.03 9.28-137.81 16.681-206.84 20.896" stroke="#8DC63F" strokeWidth="16" strokeMiterlimit="10" strokeLinecap="round" />
			<path d="M1933.79 446.983c-80.43 12.799-163.61 24.057-247.4 32.785" stroke="#6BAF45" strokeWidth="16" strokeMiterlimit="10" strokeLinecap="round" style={{ mixBlendMode: 'multiply' }} />
		</svg>
	)
}
